var fr = {
	"neptune.Button.loadingAriaLabel": "chargement",
	"neptune.Chips.ariaLabel": "Effacer {choice}",
	"neptune.ClearButton.ariaLabel": "Effacer",
	"neptune.CloseButton.ariaLabel": "Fermer",
	"neptune.DateInput.day.label": "Jour",
	"neptune.DateInput.day.placeholder": "JJ",
	"neptune.DateInput.month.label": "Mois",
	"neptune.DateInput.year.label": "Année",
	"neptune.DateInput.year.placeholder": "AAAA",
	"neptune.DateLookup.day": "jour",
	"neptune.DateLookup.goTo20YearView": "Accéder à la vue sur 20 ans",
	"neptune.DateLookup.month": "mois",
	"neptune.DateLookup.next": "suivant",
	"neptune.DateLookup.previous": "précédent",
	"neptune.DateLookup.selected": "sélectionnée",
	"neptune.DateLookup.twentyYears": "20 ans",
	"neptune.DateLookup.year": "année",
	"neptune.FlowNavigation.back": "revenir à l'étape précédente",
	"neptune.Info.ariaLabel": "Plus d'informations",
	"neptune.Label.optional": "(facultatif)",
	"neptune.Link.opensInNewTab": "(ouvre dans un nouvel onglet)",
	"neptune.MoneyInput.Select.placeholder": "Sélectionner une option...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Sélectionnez une devise",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Sélectionnez une option…",
	"neptune.Select.searchPlaceholder": "Recherche...",
	"neptune.SelectInput.noResultsFound": "Aucun résultat trouvé",
	"neptune.SelectOption.action.label": "Sélectionner",
	"neptune.SelectOption.selected.action.label": "Modifier l'option choisie",
	"neptune.StatusIcon.iconLabel.error": "Erreur :",
	"neptune.StatusIcon.iconLabel.information": "Informations :",
	"neptune.StatusIcon.iconLabel.pending": "En attente :",
	"neptune.StatusIcon.iconLabel.success": "Terminé :",
	"neptune.StatusIcon.iconLabel.warning": "Avertissement :",
	"neptune.Summary.statusDone": "Validé",
	"neptune.Summary.statusNotDone": "À compléter",
	"neptune.Summary.statusPending": "En attente",
	"neptune.Table.actionHeader": "Action",
	"neptune.Table.emptyData": "Aucun résultat trouvé",
	"neptune.Table.loaded": "Les données du tableau ont été chargées",
	"neptune.Table.loading": "Chargement des données du tableau",
	"neptune.Table.refreshPage": "Rafraichir la page",
	"neptune.Upload.csButtonText": "Envoyer un autre fichier ?",
	"neptune.Upload.csFailureText": "Échec du téléchargement. Veuillez réessayer",
	"neptune.Upload.csSuccessText": "Téléchargement terminé !",
	"neptune.Upload.csTooLargeMessage": "Veuillez fournir un fichier de moins de {maxSize} Mo",
	"neptune.Upload.csWrongTypeMessage": "Format non pris en charge. Veuillez réessayer avec un fichier différent",
	"neptune.Upload.psButtonText": "Annuler",
	"neptune.Upload.psProcessingText": "Téléchargement...",
	"neptune.Upload.retry": "Réessayer",
	"neptune.Upload.usButtonText": "Ou sélectionnez un fichier",
	"neptune.Upload.usDropMessage": "Déposer un fichier pour démarrer le téléchargement",
	"neptune.Upload.usPlaceholder": "Glissez-déposez un fichier de moins de {maxSize} Mo",
	"neptune.UploadButton.allFileTypes": "Tous types de fichiers",
	"neptune.UploadButton.dropFiles": "Déposer un fichier pour démarrer le téléchargement",
	"neptune.UploadButton.instructions": "{fileTypes}, inférieur à {size} Mo",
	"neptune.UploadButton.maximumFiles": "Max. {maxFiles} fichiers",
	"neptune.UploadButton.uploadFile": "Envoyer le fichier",
	"neptune.UploadButton.uploadFiles": "Transférer des documents",
	"neptune.UploadInput.deleteModalBody": "La suppression de ce fichier sera définitive sur notre système.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Annuler",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Supprimer",
	"neptune.UploadInput.deleteModalTitle": "Voulez-vous vraiment supprimer ce fichier ?",
	"neptune.UploadInput.fileIsTooLarge": "Fichier trop lourd",
	"neptune.UploadInput.fileTypeNotSupported": "Type de fichier non pris en charge",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Nous sommes désolés, ce téléchargement a échoué car nous ne pouvons accepter que {maxFilesAllowed} fichiers à la fois.",
	"neptune.UploadItem.deleting": "Suppression...",
	"neptune.UploadItem.removeFile": "Supprimer le fichier {filename}",
	"neptune.UploadItem.uploaded": "Téléchargé",
	"neptune.UploadItem.uploadedFile": "Fichier téléchargé",
	"neptune.UploadItem.uploading": "Téléchargement...",
	"neptune.UploadItem.uploadingFailed": "Échec du téléchargement"
};

export { fr as default };
//# sourceMappingURL=fr.json.mjs.map
